import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c9c5ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-xs"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["data-testid", "value"]
const _hoisted_4 = {
  key: 0,
  class: "transparent-bg tw-h-7 tw-w-9"
}
const _hoisted_5 = {
  key: 2,
  class: "tw-absolute tw-right-0 tw-top-8 tw-z-50 tw-w-auto tw-rounded-md tw-border tw-border-gray-200 tw-bg-white tw-p-0 tw-shadow-lg"
}
const _hoisted_6 = { class: "tw-space-y-4 tw-p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-between" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "tw-text-sm tw-font-semibold tw-text-gray-900" }, "Choose Color")
], -1))
const _hoisted_8 = { class: "tw-space-y-4" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_10 = ["id", "required", "value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "tw-mt-3 tw-border-t tw-pt-3"
}
const _hoisted_13 = { class: "tw-mb-3 tw-flex tw-items-center tw-gap-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-font-medium tw-text-gray-500" }, "Brand Kit Colors", -1))
const _hoisted_15 = { class: "tw-flex tw-max-w-[240px] tw-flex-wrap tw-gap-2" }
const _hoisted_16 = ["aria-label", "onClick"]

import { BrandKit } from '@goldcast/api/backend';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';

import BrandKitGoToSelectPrompt from '@/studio/lookAndFeel/components/BrandKitGoToSelectPrompt.vue';
import TablerBrush from '@/studioComponents/Icons/tabler/TablerBrush.vue';
import { destructureRgbColor, rgbaToHex } from '@/utils/color';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorPickerPopover',
  props: {
  id: { type: String, default: '' },
  label: { type: String, default: '' },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  initialColor: { type: String, default: 'rgba(0, 0, 0, 1)' }
},
  emits: ["colorChange"],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();
const isOpen = ref(false);

const currentColor = ref(
  destructureRgbColor(props.initialColor) || { red: 0, green: 0, blue: 0, alpha: 1, style: 'rgba(0, 0, 0, 1)' }
);

watch(
  () => props.initialColor,
  newColor => {
    const destructured = destructureRgbColor(newColor);
    if (destructured) {
      currentColor.value = destructured;
    }
  }
);

const selectedBrandKit = computed<BrandKit | null>(() => store.state.studioBrandKit.selectedBrandKit);

const brandKitColors = computed<string[]>(() => {
  if (!selectedBrandKit.value?.colors) {
    return [];
  }
  const colors = selectedBrandKit.value.colors;

  return [...colors.primary, ...colors.secondary, ...colors.neutral];
});

const textInputValue = computed<string>(() => {
  return rgbaToHex(currentColor.value.style, true);
});

const hexColor = computed<string>(() => {
  return rgbaToHex(currentColor.value.style, false);
});

const isTransparent = computed<boolean>(() => {
  return currentColor.value.alpha === 0;
});

function openColorPicker() {
  if (props.disabled) {
    return;
  }
  isOpen.value = true;
}

function emitColorChange(colorString: string) {
  const destructured = destructureRgbColor(colorString);
  if (destructured) {
    currentColor.value = destructured;
    emit('colorChange', {
      ...destructured,
      hex: rgbaToHex(destructured.style, true)
    });
  }
}

function handleColorInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emitColorChange(target.value);
}

function handleTextInput(event: Event) {
  const target = event.target as HTMLInputElement;
  const value = target.value.trim();
  if (value.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
    emitColorChange(value);
  }
}

function handleBrandKitColorClick(color: string) {
  emitColorChange(color);
}

function handleGoToSelectBrandKit() {
  isOpen.value = false;
  store.commit('branding/setSection', { sectionId: 'brandKit', moduleId: 'selectBrandKit' });
}

return (_ctx: any,_cache: any) => {
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-relative", {
      'tw-flex tw-items-center tw-justify-between': !!__props.label
    }])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      ref: "colorPickerButton",
      class: _normalizeClass(["tw-ml-4 tw-flex tw-h-7 tw-w-[130px] tw-cursor-pointer tw-items-center tw-overflow-hidden tw-rounded-md tw-border tw-text-2xs tw-leading-5 focus-within:tw-border-deep-orange-500 dark:tw-bg-neutral-900", {
        'tw-cursor-not-allowed': __props.disabled
      }]),
      disabled: __props.disabled,
      onClick: openColorPicker
    }, [
      _createElementVNode("input", {
        type: "text",
        class: _normalizeClass(["tw-h-7 tw-w-[80px] tw-flex-1 tw-border-none tw-font-mono tw-text-xs tw-text-black focus:tw-border-transparent focus:tw-ring-transparent dark:tw-text-white", {
          'tw-cursor-pointer': !__props.disabled,
          'tw-cursor-not-allowed': __props.disabled
        }]),
        "data-testid": __props.label.replaceAll(' ', '-').toLowerCase(),
        value: textInputValue.value,
        readonly: ""
      }, null, 10, _hoisted_3),
      (isTransparent.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "tw-h-7 tw-w-9 tw-border-l",
            style: _normalizeStyle({ 'background-color': currentColor.value.style })
          }, null, 4)),
      (isOpen.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    id: __props.id,
                    type: "color",
                    required: __props.required,
                    value: hexColor.value,
                    class: "tw-h-12 tw-w-12 tw-cursor-pointer tw-rounded-md tw-border tw-border-gray-300",
                    onInput: handleColorInput
                  }, null, 40, _hoisted_10),
                  _createElementVNode("input", {
                    type: "text",
                    value: hexColor.value,
                    class: "focus:tw-ring-primary tw-flex-1 tw-rounded-md tw-border tw-bg-white tw-px-2 tw-py-1.5 tw-font-mono tw-text-xs focus:tw-outline-none focus:tw-ring-1",
                    placeholder: "#000000",
                    onInput: handleTextInput
                  }, null, 40, _hoisted_11)
                ]),
                (brandKitColors.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(TablerBrush, { class: "tw-h-4 tw-w-4 tw-text-gray-500" }),
                        _hoisted_14
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandKitColors.value, (color, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: `color-${index}`,
                            type: "button",
                            class: "hover:tw-border-primary focus:tw-ring-primary tw-h-8 tw-w-8 tw-rounded-md tw-border-2 tw-border-gray-300 tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-1",
                            style: _normalizeStyle({ backgroundColor: color }),
                            "aria-label": `Select brand kit color ${color}`,
                            onClick: ($event: any) => (handleBrandKitColorClick(color))
                          }, null, 12, _hoisted_16))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createBlock(BrandKitGoToSelectPrompt, {
                      key: 1,
                      class: "tw-mt-3 tw-border-t tw-pt-3",
                      onGoToSelectBrandKit: handleGoToSelectBrandKit
                    }))
              ])
            ])
          ])), [
            [_directive_studio_click_outside, () => (isOpen.value = false)]
          ])
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ], 2))
}
}

})